<template>
  <div v-if="Object.keys(level).length > 0">
    <!-- {{ level }} -->
    <van-divider />
    <van-row>
      <van-col span="16" align="left">
        <div v-bind:class="gCheckLvData(level) ? '' : 'C4'">
          {{ level.text }}
        </div>
      </van-col>
      <van-col span="8" align="right" v-if="level.limit > 0">
        <span v-if="level.lock">必選</span>
        <span v-if="!level.lock">最多可選</span>
        <span class="C1"> {{ level.limit }} </span>項
        <!-- {{ gCheckLvData(level) }} -->
      </van-col>
    </van-row>
    <!-- !!{{ level }}!! -->
    <div v-if="level.id == 'userNote'">
      <div v-for="s2 in level.options" :key="s2.ItemName">
        <S2Input :s2="s2" />
      </div>
    </div>

    <div v-else>
      <van-tag
        size="large"
        :plain="tag != '全部'"
        v-bind:color="sGetConfig('color2')"
        @click="tag = '全部'"
        v-if="getGroupTags().length > 0"
        >#全部</van-tag
      >

      <van-tag
        v-for="t in getGroupTags()"
        :key="t"
        size="large"
        :plain="tag != t"
        v-bind:color="sGetConfig('color2')"
        @click="tag = t"
        >#{{ t }}</van-tag
      >

      <div v-for="s2 in tagOptions(level.options)" :key="s2.ItemName">
        <S2Stepper :s2="s2" v-if="level.num" @change="onChange" />
        <S2Checkbox :s2="s2" v-else @change="onChange" />

        <div class="tab" v-if="level.type == 'S1' && getGroupsText(s2.Groups)">
          包含
          <van-tag size="large">
            {{ getGroupsText(s2.Groups) }}
          </van-tag>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.tab {
  margin-left: 1.8rem;
}
.van-col {
  font-size: 0.8rem;
  /* font-weight: bold; */
  color: grey;
}
.el-button {
  font-size: 1rem;
}
.van-tag {
  margin: 1rem 0.4rem 1rem 0.4rem;
  font-size: 1rem;
  padding: 0.5rem;
}
</style>

<script>
// import Swipe from "./Swipe.vue";
import S2Checkbox from "./S2-Checkbox.vue";
import S2Stepper from "./S2-Stepper.vue";
import S2Input from "./S2-Input.vue";
export default {
  components: {
    S2Checkbox,
    S2Stepper,
    S2Input,
  },
  props: {
    level: Object,
  },
  data() {
    return {
      tag: "全部",
    };
  },
  methods: {
    getGroupTags() {
      if (!this.level.groupTags) return [];
      return this.level.groupTags;
    },
    tagOptions(pOptions) {
      if (this.tag == "全部") return pOptions;
      let array = pOptions;
      array = pOptions.filter((r) => r.Tags.find((el) => el == this.tag));
      console.log("array", array);
      // const result = words.filter((word) => word.length > 6);

      return array;
    },
    clearLv(item) {
      if (this.level.limit != 1) {
        return;
      }
      if (item.Qty) {
        this.level.options.map((r) => {
          if (r.ItemName != item.ItemName) {
            r.Qty = 0;
            // r.Qty = this.val(r.DefaultQty);
            this.clear(r); //遞迴往下清除
          }
        });
      }
    },
    onChange(item) {
      this.clearLv(item); //如果數量控制=1，選取項目時，自動清除其它項

      if (item.Qty) {
        if (item.Groups.length > 0) {
          this.$emit("click", item);
        }
      } else {
        this.clear(item);
      }
    },
    clear(item) {
      item.Groups.map((lv) => {
        lv.options.map((r) => {
          r.Qty = 0;
          r.Qty = this.val(r.DefaultQty);
          this.clear(r); //遞迴往下清除
        });
      });
    },
    getGroupsText(g) {
      if (g.length == 0 || g == undefined) {
        return "";
      }
      var array = [];
      g.forEach((r) => {
        array.push(r.text);
      });

      return array.join(" / ");
    },
  },
};
</script>
